<template>
  <div class="web-camera">
    <input v-if="initFlag" :ref="'cameraBtn' + index" class="cameraBtn" type="file" :disabled="disabled"
      accept="image/jpg,image/jpeg,image/png" mutiple="mutiple" capture="camera" @change="inputChange" />
    <!-- <img v-show="imgObj.imgSrc" class="del" @click="delImg()" :src="require('@img/newCode/icon-img-del.svg')"> -->
    <div class="imageBox">
      <img v-if="imgObj.imgSrc" class="imageContent" :class="{'success': ['0','1','4'].includes(imgObj.REVIEW_STATUS)}" :src="getSrc(imgObj)" alt="" @click="openCamera(false)">
      <div v-else class="photoBtn"  @click="openCamera(true)">
        <img :src="placeHolderImg">
        <span>{{addTip}}</span>
      </div>
      <i  v-show="imgObj.imgSrc" :class="{'el-icon-check': ['0','1','4'].includes(imgObj.REVIEW_STATUS), 'el-icon-close': ['0','1','4'].indexOf(imgObj.REVIEW_STATUS) == -1,  'web-camera-mask': true}"
      @click="openCamera(false)" ></i>
      <!-- <img v-show="imgObj.imgSrc" icon="el-icon-success" :src="['0','1','4'].includes(imgObj.REVIEW_STATUS)?loadImg:failImg" alt="" class="web-camera-mask" @click="openCamera(false)"> -->
    </div>
    <div class='camerafooter' @click="openCamera(!imgObj.imgSrc)"><img :src="scanImgSrc" class="scanImgSrc"><span>{{
      imgObj.imgSrc ? '重新采集' + imgObj.itemTitle : imgObj.itemTitle }}</span></div>
  </div>
</template>
  
<script>
import imgTools from "@/components/imageNode/child/imgTools";
import oppService from "@/service/opp-service";

export default {
  components: {

  },
  props: ["options", "imgObj", "index", "beforeOpenCamera", "disabled"],
  data () {
    return {
      src: null,
      blob: null,
      base64: null,
      maxSize: 500 * 1024,
      isCompress: true,
      placeHolderImg: require("@img/newCode/normalOcr/icon-line-plus.svg"),
      addTip:"请上传图片",
      scanImgSrc: require("@img/newCode/old/icon-idcard-scan.svg"),
      initFlag: true,
      faceImgList: ["070"],
      // loadImg: require("@img/newCode/normalOcr/success_upload.png"),
      // failImg: require("@img/newCode/normalOcr/error_upload.png"),
      fileUploadSize: "",
    };
  },
  async created () {
    this.fileUploadSize = await oppService.getSysCommonParamsFromCacheObjs("FXC_FILE_UPLOAD_SIZE") || "50";

    //默认内置两套占位图，身份证正反面2页，工商营业执照1页，也可外部入参传入
    if (this.options.placeHolderType == "0") {
      this.addTip = this.index == 0 ? "点击上传照片" : "点击上传照片";
    } else if (this.options.placeHolderType == "1") {
      this.addTip = "点击上传照片";
      //0c2替换成经办人免冠图片
      if (_.indexOf(this.faceImgList, this.imgObj.IMG_CLS) != -1) {
        this.addTip = "点击上传照片";
      }
    } else if (this.options.placeHolderImgList && this.options.placeHolderImgList.length) {
      let path = this.options.placeHolderImgList[this.index] || this.options.placeHolderImgList[0];
      // this.placeHolderImg = (await import(`${path}`)).url;
    }
  },
  computed: {
  },
  methods: {
    //图片上传成功，上传数据
    getSrc (item){
      if(item.localImgUrl&&item.localImgUrl.startsWith("blob:http:")){
        return item.localImgUrl;
      }
      if(!item.imgSrc){
        return "";
      }
      let base64Str = "data:image/jpg;base64," + item.imgSrc.replace(/data:(.*?),/, "");
      let localImgUrl = imgTools.getBase64URL(base64Str);
      item.localImgUrl = localImgUrl;
      return item.localImgUrl;
    },
    delImg () {
      //需要调用接口
      this.$emit("delImg", this.index);
      console.log("删除图像", this.index);
    },
    openPhoto () {
      // document.getElementById("cameraBtn").click();
      this.$refs["cameraBtn" + this.index].value = "";
      this.$refs["cameraBtn" + this.index].click();
    },
    inputChange (e) {
      const file = e.target.files[0];
      //拍照清除旧数据
      this.imgObj.localImgUrl = "";
      this.dealPhoto(file);
    },
    /**
     * @param blob      BLOB对象
     * @param base64    base64字符串
     */
    cutChange ({ blob, base64 }) {
      this.blob = blob;
      this.base64 = base64;
    },

    async backImg (result, fileType) {
      consoleLog("backImg:" + result.length);
      this.imgObj.imgSrc = result;
      this.$refs["cameraBtn" + this.index].value = "";
      this.initFlag = false;
      setTimeout(() => {
        //重新渲染
        this.initFlag = true;
      }, 200);
      this.$emit("onPhotoResult", { flag:"0", msg: "获取图片成功", imgBase64: result, imgSize: result.length, index: this.index, fileType: fileType });
    },
    dealPhoto (file) {
      let self = this;
      this.maxSize = this.options && this.options.maxSize || 500 * 1024;
      this.isCompress = this.options && (this.options.isCompress === false ? false : true);
      if (!file || !window.FileReader) {
        console.log("无法读取文件");
        this.$emit("onPhotoResult", { flag:"-1", msg: "设备不支持读取文件", imgBase64: "", imgSize: 0 });
        return;
      }
      if (file.size > parseInt(this.fileUploadSize) * 1024 * 1024) {
        consoleLog("文件无法上传, 请上传30M大小以内的图片！");
        this.$emit("onPhotoResult", { flag:"-1", msg: "文件无法上传, 请上传"+this.fileUploadSize+"M大小以内的图片！", imgBase64: "", imgSize: 0 });
        return;
      }
      let reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onloadend = function () {
        let result = this.result;
        //500k
        if (result.length <= self.maxSize || !self.isCompress) {
          self.backImg(result, file.type);
        } else {
          let img = new Image();
          img.src = result;
          img.onload = () => {
            let canvas = document.createElement("canvas");
            let ctx = canvas.getContext("2d");
            canvas.width = img.width;
            canvas.height = img.height;
            ctx.drawImage(img, 0, 0, img.width, img.height);
            let compressData = self.compressImg(canvas, 0.8);
            self.backImg(compressData, file.type);
          };
        }
      };

    },
    //压缩图片
    compressImg (canvas, quality) {
      console.log("compressImg:" + quality);
      let compressData = canvas.toDataURL("image/jpeg", quality);
      if (compressData.length >= this.maxSize) {
        if (quality <= 0) {
          quality = 0.1;
          compressData = canvas.toDataURL("image/jpeg", quality);
        } else {
          compressData = this.compressImg(canvas, parseFloat((quality - 0.2).toFixed(1)));
        }
      }
      return compressData;
    },
    showSwipter () {
      this.$emit("showSwipter", {
        flag: true,
        index: this.index
      });
    },
    openCamera (isOpen) {
      if (!isOpen) {
        //打开影像大图
        this.showSwipter();
        return;
      }
      if(this.beforeOpenCamera && !this.beforeOpenCamera(this.index)){
        return false;
      }
      try {
        this.openPhoto();
      } catch (e) {

      }
    }
  },
  // ...
};
</script>
  
<style lang="less" >
.web-camera {
  // width: 250px;
  width: 389px;
  // height: 200px;
  cursor: pointer;
  height: 246px;
  display: flex;
  flex-direction: column;
  flex: 0;
  border-radius: 8px 8px 8px 8px;
  margin-left: 44px;
  position: relative;
  .web-camera-mask{
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    font-size: 0.6rem;
    color: white;
    padding: 0.1rem;
    border-radius: 0.4rem;
  }
  .el-icon-check{
    background: rgb(5,175,14);
  }
  .el-icon-close{
    background: red;
  }
  .cameraBtn {
    display: none;
  }

  .imageContent,
  .photoBtn {
    width: 389px;
    height: 249px;
    border: 1px solid #D0D0D0;
    display: flex;
    justify-content: center;
    flex-direction: column;
    align-items: center;
    background: #F5F5F5;
    object-fit: contain;
    img{
      width: 40px;
      height: 40px;
      margin-bottom: 20px;
    }
  }

  .del {
    position: absolute;
    right: 0;
    z-index: 100;
  }

  .camerafooter {
    width: 100%;
    height: 40px;
    display: row;
    color: #252525;
    font-size: 16px;
    line-height: 1;
    text-align: center;
    border-radius: 0px 0px 8px 8px;
    padding-top: 20px;
    box-sizing: border-box;

    .scanImgSrc {
      width: 13px;
      height: 13px;
      padding-right: 10px;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/preEntry/WebCamera.vue